export default "__VITE_PUBLIC_ASSET__ffa67c1c__"